<h2 mat-dialog-title>Create Group</h2>

<mat-dialog-content>
  <mat-form-field>
    <input matInput type="text" [formControl]="groupName" placeholder="Group Name" (keyup.enter)="submit()" />
    <mat-hint align="end">{{ groupName.value.length }}/50</mat-hint>
    <mat-error *ngIf="groupName.errors && (groupName.dirty || groupName.touched)">
      <div *ngIf="groupName.errors.required">Group name is <strong>required</strong>.</div>
      <div *ngIf="groupName.errors.existingName">This group name already exists.</div>
    </mat-error>
  </mat-form-field>
</mat-dialog-content>

<div fxLayout="row" fxLayoutAlign="end" style="margin-top: 15px;">
  <button mat-raised-button color="primary" [mat-dialog-close]="groupName.value" [disabled]="!groupName.valid">Create</button>
</div>
